import { ArrowsIcon } from "assets/icons";
import { If } from "components";
import { useBoolean, useOnClickOutside } from "hooks";
import { UserRole } from "modules/auth";
import { useRef } from "react";
import { Avatar, Icon } from "ui";

import { useCurrentPortalUser } from "../../hooks";
import CompanyLogoutModal from "../CompanyLogoutModal/CompanyLogoutModal";

// Reuse admin profile-block styles to keep look identical with the main sidebar.
import styles from "../../../common/components/ProfileBlock/ProfileBlock.module.scss";

const CompanyProfileBlock = () => {
  const containerRef = useRef(null);

  const {
    value: isOpenModal,
    setFalse: closeModal,
    toggle: toggleModal
  } = useBoolean(false);

  useOnClickOutside(containerRef, closeModal);

  const { company, manager, role } = useCurrentPortalUser();

  const isManager = role === UserRole.CompanyManager;

  const displayName = isManager
    ? `${manager?.firstname ?? ""} ${manager?.lastname ?? ""}`.trim() ||
      manager?.email ||
      ""
    : (company?.name ?? company?.email ?? "");
  const displayRole = isManager ? "Manager" : "Company";

  const avatarImage = company?.avatar
    ? ({ url: company.avatar.url, id: company.avatar.id } as never)
    : undefined;

  return (
    <div ref={containerRef} className={styles.profile} onClick={toggleModal}>
      <div className={styles.profile__avatar}>
        <Avatar
          image={avatarImage}
          dimensions={{ width: 40, height: 40, borderRadius: "100px" }}
        />
      </div>

      <div className={styles.profile__info}>
        <p className={styles.profile__info__name}>{displayName}</p>
        <p className={styles.profile__info__role}>{displayRole}</p>
      </div>

      <Icon as={ArrowsIcon} boxSize={16} color="#090914" />

      <If condition={isOpenModal}>
        <CompanyLogoutModal />
      </If>
    </div>
  );
};

export default CompanyProfileBlock;
